import { useTranslation } from 'react-i18next';

import { Heading, Spinner } from '@ctct/presentation-layer';
import { PaymentStrategy } from '@ctct/state-server-layer';

import { InHousePaymentMethodsWidgetContent } from './InHousePaymentMethodsWidgetContent';
import { StripePaymentWidget } from './StripePaymentWidget';
import type { PaymentMethodsWidgetProps } from './usePaymentMethodsWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const PaymentMethodsWidget = (props: PaymentMethodsWidgetProps) => {
  const { t } = useTranslation();
  const { data, handlers, status, hideHeading, hooks } = props;
  const isLoading = hooks.useFullLoading();
  const isUpdatingStripeLocaleConfig = hooks.useUpdatingStripeLocaleConfig();

  return (
    <>
      {!hideHeading && (
        <Heading>
          {t('payment-methods.heading')}{' '}
          {status === 'loaded' && data.getIsUpdatingStripeLocaleConfig(isUpdatingStripeLocaleConfig) ? (
            <Spinner size="sm" />
          ) : null}
        </Heading>
      )}
      <WithStatusHandling
        skeletonHeight={props.paymentStrategy === PaymentStrategy.Stripe ? 370 : 210}
        status={status}
        errorMessage={status === 'error' ? data.message : undefined}
        retry={status === 'error' ? handlers.retry : undefined}
      >
        {status === 'loaded' && props.paymentStrategy === PaymentStrategy.Stripe && (
          <StripePaymentWidget isLoading={isLoading} {...props} />
        )}
        {status === 'loaded' && props.paymentStrategy === PaymentStrategy.Paas && (
          <InHousePaymentMethodsWidgetContent {...props} />
        )}
      </WithStatusHandling>
    </>
  );
};
